import { createFileRoute, Link } from '@tanstack/react-router';
import { Box, Breadcrumbs, Link as MuiLink, Stack, Typography } from '@mui/material';
import { BatchInvoiceImport } from '@/components/BatchInvoiceImport';

export const Route = createFileRoute('/_authenticated/invoices/import')({
  component: ImportInvoicesPage,
});

function ImportInvoicesPage(): JSX.Element {
  return (
    <Box>
      <Stack spacing={1} sx={{ mb: 3 }}>
        <Breadcrumbs separator="›" aria-label="breadcrumb">
          <MuiLink component={Link} to="/invoices" underline="hover" color="inherit">
            Comprobantes
          </MuiLink>
          <Typography color="text.primary">Importar CSV</Typography>
        </Breadcrumbs>
        <Typography variant="h4">Importar facturas desde CSV</Typography>
        <Typography variant="body2" color="text.secondary">
          Cargá un archivo con hasta 100 filas. Validamos cada fila client-side y emitimos
          secuencialmente contra AFIP — el orden y los CAE se preservan en el resultado.
        </Typography>
      </Stack>

      <BatchInvoiceImport />
    </Box>
  );
}
